import { useMutation } from '@tanstack/react-query';
import driverinfosecurity from '../utils/DriverInfoSecurity';
import { TokenData } from '../components/interfaces/interfaces';
import { correlationId } from '../utils/correlationId';

interface LoginPayload {
    username: string;
    password: string;
}

export function useLogin() {
    return useMutation<void, Error, LoginPayload>({
        mutationFn: async ({ username, password }) => {
            const response = await fetch('api/signin/', {
                method: 'POST',
                body: JSON.stringify({ UserId: username, Password: password }),
                headers: { 'Content-Type': 'application/json', 'X-Correlation-ID': correlationId }
            });
            if (!response.ok) {
                throw new Error('Failed to log in');
            }
            const data: TokenData = await response.json();
            driverinfosecurity.saveAccessToken(data);
        }
    });
}
